export default function TileMatchIcon() {
  const tile = (x: number, y: number, glyph: string, top = false) => (
    <g>
      <rect x={x + 3} y={y + 3} width="20" height="26" rx="4" fill="#1f8f7a" />
      <rect x={x + 1.5} y={y + 1.5} width="20" height="26" rx="4" fill="#c9b98f" />
      <rect x={x} y={y} width="20" height="26" rx="4" fill={top ? '#fff4b8' : '#fffdf4'} stroke={top ? '#ff8a1f' : '#a89a70'} strokeWidth={top ? 2 : 1} />
      <text x={x + 10} y={y + 18} fontSize="13" textAnchor="middle">
        {glyph}
      </text>
    </g>
  );
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="2" y="2" width="60" height="60" rx="10" fill="#1e7a5c" />
      {tile(6, 26, '🐼')}
      {tile(36, 26, '🍓')}
      {tile(21, 10, '🍓', true)}
      <path d="M48 8l2 4 4 .6-3 3 .8 4.4-3.8-2-3.8 2 .8-4.4-3-3 4-.6z" fill="#ffd84d" />
    </svg>
  );
}
